.machine-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(580px, 1fr));
  align-items: start;
  max-width: 1600px;
  margin: 0.75rem auto;
  gap: 1.5rem;
}

@media (max-width: 768px) {
  .machine-grid {
    grid-template-columns: 1fr;
  }
}

.search-form {
  position: relative;
  width: 100%;
  max-width: 680px;
  margin: 0 auto 1rem;
}

.search-input {
  width: 100%;
  padding: 0.75rem 2.5rem 0.75rem 1rem;
  border: 1px solid rgba(0, 0, 0, 0.15);
  border-radius: 0.75rem;
  outline: none;
}

.search-input:focus {
  border-color: #2684ff;
  box-shadow: 0 0 0 3px rgba(38, 132, 255, 0.2);
}

.search-input::-webkit-search-cancel-button,
.search-input::-webkit-search-decoration {
  appearance: none;
  display: none;
}

.search-input::-ms-clear {
  display: none;
  width: 0;
  height: 0;
}

.btn-search,
.btn-clear {
  position: absolute;
  top: 50%;
  right: 0.5rem;
  transform: translateY(-50%);
  width: 2rem;
  height: 2rem;
  display: grid;
  place-items: center;
  border: 0;
  background: transparent;
  cursor: pointer;
  padding: 0;
  box-shadow: none;
}

.btn-search:hover,
.btn-clear:hover,
.btn-search:focus,
.btn-clear:focus,
.btn-search:active,
.btn-clear:active {
  background: transparent;
  box-shadow: none;
}

.btn-search:focus-visible,
.btn-clear:focus-visible {
  outline: 2px solid #2684ff;
  outline-offset: 2px;
  border-radius: 0.5rem;
}

.btn-search svg,
.btn-clear svg {
  pointer-events: none;
}

.expand-btn-div {
  width: 100%;
  max-width: 1600px;
  margin: 0 auto 1rem;
  display: flex;
  justify-content: flex-end;
}

.expand-all-button {
  background-color: #0d6efd;
  color: #fff;
  border: 0;
  border-radius: 6px;
  padding: 0.295rem 0.7rem;
  font-size: 0.875rem;
  font-weight: 500;
  cursor: pointer;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  transition: transform 0.15s ease;
  margin-top: 0.2rem;
  min-width: 128px;
  text-align: center;
}

.expand-all-button:hover {
  background-color: #0b5ed7;
}

.expand-all-button:active {
  transform: scale(0.97);
}

.expand-all-button:focus-visible {
  outline: none;
  box-shadow: 0 0 0 3px rgba(13, 110, 253, 0.5);
}

.card {
  width: 100%;
  align-self: start;
  border: 1px solid #ccc;
  border-radius: 8px;
  background-color: #fff;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.05);
  overflow: hidden;
}

.card-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0.75rem 1rem;
  background-color: #f8f9fa;
  font-weight: bold;
  font-size: 0.9rem;
}

.card-header:focus-visible,
.card-header:focus-within {
  outline: none;
  border-radius: 8px;
  box-shadow: 0 0 0 3px rgba(0, 123, 255, 0.4);
}

.card-header button:focus-visible {
  outline: none;
  box-shadow: 0 0 0 3px rgba(0, 123, 255, 0.4);
  border-radius: 8px;
}

.card-header:hover {
  background-color: #e8e8e8;
}

.card-header:hover .arrow {
  color: #ababab;
}

.card:has(.card-header:focus-visible),
.card:has(.card-header:focus-within) {
  outline: none;
  border-radius: 8px;
  box-shadow: 0 0 0 3px rgba(0, 123, 255, 0.4);
}

.header-row {
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
  margin-bottom: 0.5rem;
}

.header-row .heading {
  margin: 0;
  flex: 1 1 auto;
}

.arrow {
  transition: transform 0.02s ease;
}

.arrow-rotated {
  transform: rotate(180deg);
}

.delete-button {
  background: transparent;
  font-size: 0.85rem;
  border: 0;
  padding: 0.3rem;
  border-radius: 0.4rem;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #888;
  transition: background-color 0.2s ease, color 0.2s ease;
}

.delete-button:hover {
  background-color: #e8e8e8;
  color: #c7c7c7;
}

.card-actions {
  display: flex;
  gap: 0.4rem;
  align-items: center;
}

.card-title {
  font-size: 1rem;
  margin-right: 1rem;
}

.card-subtitle {
  font-size: 0.8rem;
  color: #6c757d;
}

.card-body {
  display: block;
  padding: 1rem;
  font-size: 0.825rem;
  word-wrap: break-word;
  overflow-wrap: anywhere;
}

.card-body img {
  max-width: 100%;
  height: auto;
  display: block;
}

.row {
  display: grid;
  grid-template-columns: 120px 1fr;
  column-gap: 0.5rem;
  align-items: start;
}

.label {
  font-weight: bold;
  color: #343a40;
  align-self: start;
}

.upload-button {
  font-size: 16px;
  background: transparent;
  border: 0;
  padding: 2px;
  line-height: 0;
  margin-left: 0.3rem;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

.upload-button:focus-visible {
  outline: none;
  box-shadow: 0 0 0 3px rgba(0, 123, 255, 0.5);
  border-radius: 4px;
}

.upload-button:hover {
  color: #0d6efd;
}

.no-wrap {
  white-space: nowrap;
}

.image-container {
  grid-column: 2;
  width: 100%;
  min-height: 300px;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  background-color: transparent;
}

.no-image-text {
  color: #888;
  font-size: 0.825rem;
}

.short-id-form {
  display: flex;
  gap: 0.5rem;
  align-items: center;
  margin-top: 0.5rem;
}

.shortid-form input {
  width: 80px;
  padding: 0.2rem 0.4rem;
  border: 1px solid #ccc;
  border-radius: 4px;
}

.button {
  padding: 0.3rem 0.7rem;
  font-size: 0.8rem;
  font-weight: 590;
  width: fit-content;
  border-radius: 0.4rem;
}

.button:disabled {
  background-color: #e0e0e0;
  color: #a0a0a0;
  border: 1px solid #a0a0a0;
}

.no-hover:hover {
  pointer-events: none;
}

.alert {
  display: flex;
  grid-column: span 2;
  align-items: center;
  gap: 0.5rem;
  border-radius: 4px;
  padding: 0.5rem;
  font-size: 0.9rem;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  width: fit-content;
  max-width: 100%;
}

.alert-success {
  background-color: #d1e7dd;
  color: #0f5132;
}

.alert-danger {
  background-color: #f8d7da;
  color: #842029;
}

.validation-message {
  color: #842029;
  font-size: 0.8rem;
  margin-top: 0.3rem;
  white-space: nowrap;
}

.card,
.card *:not(.arrow) {
  transition: none !important;
  transform: none !important;
  animation: none !important;
}

.card-body {
  will-change: auto;
}
